export class CSuggestionCreateViewModel {
    fEmail: string;
    fFullName: string;
    fSubject: string;
    fDescription: string;
    fRecaptcha: string;

    constructor() {
        this.fEmail = '';
        this.fFullName = '';
        this.fSubject = '';
        this.fDescription = '';
        this.fRecaptcha = '';
    }
}